<template>
  <EditCom
    :target="addTarget"
    :inputList="addInputList"
    :buttonList="addButtonList"
    :rules="addRules"
    :title="title"
    @closeFun="closeAdd"
    ref="edit_com"
  />
</template>

<script setup>
import {
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive
} from 'vue';
import EditCom from '@/components/EditCom/index.vue'
import { message } from '@/utils/js/initVariable'
import { dayjs } from  '@/utils/js/initVariable';

import { addRegionDirectory } from '@/api/RegionDirectoryApi';

const props = defineProps({
  target: {
    type: Object,
    default: () => ({})
  },
  title: {
    type: String,
    default: () => ({})
  }
})

const closeAdd = ()=>{
  emit('close')
}

const addSubmit = (form, target, button, loadFn) => {
  // console.log(form, target, button, loadFn);
  form.value.validate((valid) => {
    if (valid) {
      // 构造请求参数（只保留图层相关字段）
      addRegionDirectory({
        ...target,
        tags: (target['tags'] || []).map(e=> { return { name: e, } }),
      }).then((res) => {
        if (res.data.code === 1004) {
          message(`上传成功`, 1)
          closeAdd()
          emit('refresh')
        }
      }).catch((err) => {
        console.error(err)
        message('请求失败', 0)
      }).finally(() => {
        loadFn() 
      })
    } else {
      loadFn() 
    }
  })
}
// 组件EditCom
const addTarget = reactive({
  ...props.target,
  continuousTrackList: [
    { value: 1, label: '是', },
    { value: 0, label: '否', },
  ],
  tags: (props.target['tags'] || []).map(e=> e.name ),
})

const addInputList = ref([
  { name: '区域名称', prop: 'regionName', type: 'text' },
  { 
    name: '区域', 
    prop: 'regionGeom', 
    type: 'mapScopeSign',
    message: { text: '在此处绘制多边形区域' },
    polygon: { oneFlag: true }
  },
  { name: '描述', prop: 'regionDesc', type: 'textarea' },
  { name: '持续跟踪', prop: 'ifContinuousTracking', type: 'select',
    select: {
      list: 'continuousTrackList',
      value: 'value',
      label: 'label',
    }
  },
  { name: '标签', prop: 'tags', type: 'tags' },
]),
addButtonList = ref([
  { name: '取消', fun: closeAdd, type: 'danger', },
  { name: '确定', fun: addSubmit, type: 'primary', },
]),
addRules = reactive({
  regionName: [
    { required: true, message: '请输入区域名称', trigger: 'blur' },
  ]
})
const form = ref({
})

const formRef = ref(null)

const eventTypes = ref([])

const emit = defineEmits(['close', 'confirm', 'refresh'])

const editFlag = ref(false)

const close = () => {
  emit('close')
}

onMounted(() => {
  
})
</script>

<style lang="less" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}

.additional-info {
  margin-top: 16px;
}
</style>